/* Форма заказа студии: состояние, действия и реакции живут в сервисе заказа (engine-kit/order-service.ts) — тот же код
   без изменения поведения; хук отдаёт его вид для экранов React. Путь и экспорты модуля прежние. */
import type { OrderCtx } from './engine-kit/order-service';
import { useOrderService } from './engine-kit/use-order-service';

export { uploadPurpose, referenceUse, uploadFailureText, studioQuotePath } from './engine-kit/order-service';

export function useStudioForm(o: OrderCtx) {
  return useOrderService(o).view;
}
